import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { ELIMSProduct } from "../domain/ELIMS/ELIMS-Product";
import { ELIMSTest } from "../domain/ELIMS/ELIMS-test";
import { Client } from "../domain/client";
import { CoreData } from "../tools/core-data/core-data";
import { mapper } from "../tools/mapping/mapper";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { ELIMSProductDTO } from "./dto/ELIMS/elims-product.dto";
import { ELIMSTestDTO } from "./dto/ELIMS/elims-test.dto";
import { ClientDTO } from "./dto/client.dto";
import { AppConfig } from "../app.config";

@Injectable({
    providedIn: 'root',
})
export class ELIMSService extends BaseService {

    private serviceUrl = `${this.config.getConfig('serviceBaseUrl')}api/elims`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        protected override oauthService: OAuthService,
        private loadingTask: LoadingTask,
        protected override router: Router,
        private config: AppConfig) {
        super(router, coreData, oauthService, snackBare);
    }

    getMatriceList(filters: string[]) {

        this.loadingTask.activateLoading();

        let params = new HttpParams();
        filters.forEach(x => {
            params = params.append('filter', `${x}`);
        })

        return this.http.get(`${this.serviceUrl}/Matrice/byFilter`, this.generateHeaderWithParameters(params)).pipe(
            catchError(this.handleError<any>('getMatriceList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: ELIMSProductDTO[]) => {
                return response.map((item: ELIMSProductDTO) => {
                    return mapper.map(item, ELIMSProductDTO, ELIMSProduct);
                });
            }));
    }

    getTestList(filters: string[], masterProductGroupCode: string, isStrictSearch: boolean) {

        this.loadingTask.activateLoading();

        let params = new HttpParams();
        filters.forEach(x => {
            params = params.append('filter', `${x}`);
        })

        return this.http.get(`${this.serviceUrl}/Test/${masterProductGroupCode}/byFilter/${isStrictSearch}`, this.generateHeaderWithParameters(params)).pipe(
            catchError(this.handleError<any>('getTestList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: ELIMSTestDTO[]) => {
                return response.map((item: ELIMSTestDTO) => {
                    return mapper.map(item, ELIMSTestDTO, ELIMSTest);
                });
            }));
    }

    /**
     * 
     * @param text Client Code or Client Name
     * @returns 
     */
    getClientList(text: string) {
        let params = new HttpParams();
        if (text) {
            params = params.append('filter', `${text}`);
        }
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/client/byFilter`, this.generateHeaderWithParameters(params)).pipe(
            catchError(this.handleError<any>('getClientList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: ClientDTO[]) => {
                return response.map((item: ClientDTO) => {
                    return mapper.map(item, ClientDTO, Client);
                });
            }));
    }
}